/* @flow */

export type ReviewType = {
  avatar: string,
  name: string,
  review: string,
  location?: string,
  tags: [string],
};

const REVIEWS: Array<ReviewType> = [
  {
    name: 'Liz',
    avatar: 'https://s3-media1.fl.yelpcdn.com/photo/YvnxQCqni0FkQcUh3wHidg/ls.jpg',
    review:
      "Lugg is such a fast, easy, and convenient service! I've used them twice now and both moves have been amazing. I highly recommend this service to anyone who has no other way to transport big items!",
    tags: ['home-page-carousel'],
  },
  {
    name: 'David',
    avatar: 'https://s3-media1.fl.yelpcdn.com/photo/ZIqJbBQRwOp6g7dtb5uiDA/ls.jpg',
    review:
      'I bought a very large and heavy dresser and was worried about how to get it home. Lugg really saved my day! Brett and Tamas were super helpful and easy to communicate with. Definitely a five star experience!',
    tags: ['home-page-carousel'],
  },
  {
    name: 'Pam',
    avatar: 'https://s3-media2.fl.yelpcdn.com/photo/xcQmWRF8EGbCFnuOfo8MLg/ls.jpg',
    review:
      'Nestor and Jeff did a great job picking up a couch I bought on Craigslist. The whole process took maybe 30 minutes, which was such a lifesaver! I would definitely recommend Lugg to anyone!',
    tags: ['home-page-carousel'],
  },
  {
    name: 'Shereen',
    avatar: 'https://s3-media3.fl.yelpcdn.com/photo/5kSWpUTXecgUh-9sRMp05w/ls.jpg',
    review:
      'Lugg is THE best!  Solomon and Yuri were great! For my most recent purchase I coordinated a pickup elsewhere and drop off at my place. They were fast, efficient, friendly, and extremely helpful (I needed to move a piece of furniture to make some room for the item they picked up). They were in and out in 10 minutes! Thanks a ton!',
    tags: ['home-page'],
  },
  {
    name: 'Angelo',
    avatar: 'https://s3-media1.fl.yelpcdn.com/photo/t4Pykz2IJ7_-xoji4jkLuw/ls.jpg',
    review:
      'I was walking around Crate and Barrel and on a whim decided to buy a sofa and chair. I literally dropped the pin and they were already on the way before I left the store. I could not believe how quick it all happened. Jackson and Severiano were careful and quickly to get everything inside and unwrapped.  Excellent experience, friendly movers that kept in communication the whole time.  Would do it again anytime, highly recommend!',
    tags: ['store-purchases-page'],
  },
  {
    name: 'Christine',
    avatar: 'https://s3-media3.fl.yelpcdn.com/photo/TX2T9qoQ5EH-iWHxafetag/ls.jpg',
    review:
      "I’ve used Lugg twice in one week to finish moving and it's been a breeze!! Both times -- first with Jamel and Elias, and today with Severiano and Nick -- they were prompt, super nice, and super efficient. Hope I don't have to move again anytime soon (ha) but it'll definitely be less daunting now that I know I can call Lugg and they'll send over awesome folks to help me out! :).",
    tags: ['small-moves-page'],
  },
  {
    name: 'Alex',
    avatar: 'https://s3-media1.fl.yelpcdn.com/photo/1PU2LrIgWdfi5SRYUnsijQ/ls.jpg',
    review:
      'Darren and Jay help me move the rest of my furniture out of storage today. They did a great job, especially getting my sofa into the house (a feat that required some serious gymnastics). Overall the guys were careful, fast, flexible, and friendly. Thanks guys!',
    tags: ['storage-page'],
  },
  {
    name: 'Sofiane',
    avatar: 'https://s3-media3.fl.yelpcdn.com/photo/H5RuARb95-Tov48qbiRwLQ/ls.jpg',
    review:
      'Just moved to SF and bought this bed on Craigslist. Not having a car or knowing anyone with a car in the city, I requested movers through the app. They arrived at pick up location even before me! I had to move a bed and they did the job quick. Both movers were very courteous and careful about the item and about my house. Would definitely recommend to anyone and use again!',
    tags: ['craigslist-page'],
  },
  {
    name: 'Ryan',
    avatar: 'https://s3-media1.fl.yelpcdn.com/photo/YRpHYdYnTs1B2DMwz-bnzQ/ls.jpg',
    review:
      'Rick and Darren came within minutes and picked up the dining room table that we were donating to Goodwill. They were fast and very friendly! Highly recommend using Lugg when you need something moved!',
    tags: ['donations-page'],
  },
  {
    name: 'Jennifer',
    avatar: 'https://s3-media4.fl.yelpcdn.com/photo/tSCTLBZzkLfVP5MPs2OAKg/ls.jpg',
    review:
      'Lugg is awesome! As soon as I requested them they were here in less then 15 min. Grabbed all my junk and took it off my hands. I will definitely use them again and spread the word',
    tags: ['junk-removal-page'],
  },
  {
    name: 'Mattea',
    review:
      'They were wonderful! They went above and beyond to get all of my things moved, they took my things from my room, all the way to my place of storage and even put everything into my storage unit for me, and they did it all in an extremely efficient, very timely manner. They were both super friendly and very nice.',
    location: 'San Francisco',
    tags: ['public-storage'],
    avatar: '',
  },
  {
    name: 'Linna',
    review:
      'Luv my luggers!!😻 helped me with moving and since the truck was a bit small worked with me to fit everything into the truck. Gave great advice as first time trying to get rid of old furnitures helped me find the right place to do so!!! Went the extra mile and gave me suggestions on how to get rid of the few leftover items. Worked hard and fast providing great quality work. Funny, Kind and patient with me being a newbie, lol. Best ppl ever will use services again for sure😆',
    location: 'San Jose',
    tags: ['public-storage'],
    avatar: '',
  },
  {
    name: 'Ben',
    review:
      'Rick and Omar did an excellent job moving our apartment furniture into storage. They were professional and careful with our items. Would gladly work with them again.',
    location: 'San Jose',
    tags: ['public-storage'],
    avatar: '',
  },
  {
    name: 'Todd',
    review: 'Polite, Careful, & Very professional.',
    location: 'Long Beach',
    tags: ['public-storage'],
    avatar: '',
  },
  {
    name: 'Elyse',
    review:
      'Awesome! They helped me move stuff to storage. Got all my stuff down way too many flights of stairs and then packed me storage space while I filled out the paperwork. Enrique was a hero when I dropped my SS card outside without realizing it and he returned it, while stressing that I really needed to be more careful. lol. Thanks guys!',
    location: 'San Francisco',
    tags: ['public-storage'],
    avatar: '',
  },
  {
    name: 'Delilah',
    review:
      'Absolutely amazing! Organized everything and even left walking space in my storage unit. They also completed the work much faster then expected.',
    location: 'San Jose',
    tags: ['public-storage'],
    avatar: '',
  },
  {
    name: 'Miriam',
    review:
      'Lugg was wonderful!!! They put most of my apartment in a truck and delivered and unpacked it in storage!!! Highly recommended',
    location: 'Hawthorne',
    tags: ['public-storage'],
    avatar: '',
  },
  {
    name: 'Adam',
    review: 'Lugg was very helpful in moving my stuff out of my storage unit very quickly!',
    location: 'Los Angeles',
    tags: ['public-storage'],
    avatar: '',
  },
  {
    name: 'Fay',
    review:
      'My Luggers Rudy & Malik were on time, friendly and got right to it. They moved me out of my storage in no time and not only dropped off everything at the other place but helped me set up things exactly as I wanted in the new location. This was my first time using Lugg and based on this experience I will use it again and would highly recommend it!',
    location: 'San Anselmo',
    tags: ['public-storage'],
    avatar: '',
  },
  {
    name: 'Josh',
    review:
      'Such a a seamless move. Super cool guys and very easy going. Really appreciated their help',
    location: 'San Francisco',
    tags: ['public-storage'],
    avatar: '',
  },
  {
    name: 'Mike',
    review:
      'David and Grayson were amazing. On time, efficient, and went out of their way to assure that my stuff fit into a small storage unit. They reorganized things, with out asking, to make sure everything fit snuggly. They also wrapped fragile items (large tv) for me, to make sure everything arrived intact. True professionals.',
    location: 'Livermore',
    tags: ['public-storage'],
    avatar: '',
  },
  {
    name: 'Robert',
    review: 'Great guys. Loaded everything up and moved some stuff around. Very satisfied.',
    location: 'Berkeley',
    tags: ['public-storage'],
    avatar: '',
  },
  {
    name: 'Lindsay',
    review:
      'Both Anthony and Oswaldo were complete gentlemen, professionals, meticulously careful movers, and a delight to be around. I was impressed with their efficiency and expediency. High recommended!',
    location: 'Los Angeles',
    tags: ['public-storage'],
    avatar: '',
  },
  {
    name: 'Rozario',
    review:
      'Carlos and David were very efficient and delivered the sofa very carefully and quickly. They were very courteous and I highly recommend them.',
    location: 'San Mateo',
    tags: ['public-storage'],
    avatar: '',
  },
  {
    name: 'Nikki',
    review: 'I was a pain in the butt and they were totally awesome. Flexible and super cool.',
    location: 'San Francisco',
    tags: ['public-storage'],
    avatar: '',
  },
  {
    name: 'Roya',
    review:
      'They were amazing. Super friendly and efficient. I would recommend Lugg to all of my friends thanks to this experience!',
    location: 'Berkeley',
    tags: ['public-storage'],
    avatar: '',
  },
  {
    name: 'Sarah',
    review: 'They were great! Super helpful and easy to schedule. Will definitely use Lugg again.',
    location: 'Los Angeles',
    tags: ['public-storage'],
    avatar: '',
  },
  {
    name: 'Madeleine',
    review: "They were great! Fantastic attitude and 'can do' spirit!",
    location: 'San Francisco',
    tags: ['public-storage'],
    avatar: '',
  },
];

export function getReviewsTagged(reviews: Array<ReviewType>, tag: string): Array<ReviewType> {
  return reviews.filter(review => {
    return review.tags.includes(tag);
  });
}

export function getReviewTagged(reviews: Array<ReviewType>, tag: string): ReviewType {
  return getReviewsTagged(reviews, tag)[0] || reviews[0];
}

export default REVIEWS;



// WEBPACK FOOTER //
// ./src/data/Reviews.js